/*
 * @Author: Kuiper
 * @Date: 2021-08-26 20:45:04
 */
import { registerSW } from 'virtual:pwa-register'

export function setupPwa() {
  if (import.meta.env.PROD) {
    console.log('start to registerSW')
    const updateSW = registerSW({
      onNeedRefresh() {
        console.log('registerSW onNeedRefresh')
        updateSW()
      },
      onOfflineReady() {
        console.log('registerSW onOfflineReady')
      },
    })
    // updateSW()
    // navigator?.serviceWorker?.getRegistrations().then((res) => {
    //     console.log('serviceWorker getRegistrations:', res)
    // })
  }
}
